import './App.css';
import VeerJiMenu from './veerji';

function App() {
  return (
    <VeerJiMenu></VeerJiMenu>
  );
}

export default App;
